import styled from "styled-components";
import Iframe from "react-iframe";

export const ContactContainer = styled.div`
display : flex;
flex-direction : column;
justify-content : center;
align-items : center;
background : #010101;
min-height : 700px;
@media screen and ( max-width : 768px ) {
    height : 1400px;
};
@media screen and ( max-width : 480px ) {
    height : 1400px;
};`

export const ContactH1 = styled.h1`
font-size : 2.5rem;
color : #fff;
margin-bottom : 64px;

@media screen and ( max-width : 480px ) {
    font-size : 2rem;
};`;

export const BtnWrap = styled.div`
width : 320px;
display : flex;
flex-direction : column;
justify-content : space-evenly;
`;
export const ContactWrapper = styled.div`
max-width : 1100px;
margin : 0 auto;
display : grid;
grid-template-columns : 1fr 1fr;
align-items : center;
grid-gap : 16px;
padding : 0 50px;
@media screen and (max-width : 1200px){
    grid-template-columns : 1fr 1fr; 
};
@media screen and (max-width : 768px){
    grid-template-columns : 1fr;
    padding : 0 20px;
    max-width : 450px;
};
`

export const ContactCard = styled.div`
background : #fff;
display : flex;
flex-direction : column;
justify-content : flex-start;
align-items : center;
border-radius : 10px;
max-height : 540px;
max-width : 500px;
padding : 30px;
box-shadow : 0 1px 3px rgba(0, 0, 0, 0.2);
transition : all 0.2s ease-in-out;
&:hover {
    transform : scale(1.02);
    transition : all 0.2s ease-in-out;
    cursor: pointer;
};
@media screen and ( max-width : 480px ) {
    max-width : 320px;
}
`
export const NormalButton = styled.button`
margin : 10px;
border-radius : 50px;
background : ${({primary}) => (primary? "#010606": "#01bf71")};
white-space : nowrap;
padding : ${({big}) => (big?'14px 48px':'12px 30px') };
color : ${({dark}) => (dark ? '#fff':'#00000')};
font-size : ${({fontBig}) => (fontBig ? '20px': '16px')};
outline : none;
border : none;
cursor : pointer;
display : flex;
text-decoration : none;
justify-content : center;
align-items : center;
transition : all 0.2 ease-in-out;
&:hover {
    color : ${({dark}) => (dark ? '#010101':'#010606')}; 
    transition : all 0.2s ease-in-out;
    background : ${({primary}) => (primary? "#01BF71":"#010101")};
}`


export const Form = styled.form`
display : flex;
flex-direction : column;
& *{
    margin : 10px;
}; 

& [type = 'submit']{
    border-radius : 50px;
    background : #010606;
    white-space : nowrap;
    padding : 12px 30px;
    color : #fff;
    font-size : 18px;
    outline : none;
    border : none;
    cursor : pointer;
    display : flex;
    text-decoration : none;
    justify-content : center;
    align-items : center;
    transition : all 0.2 ease-in-out;
    &:hover {
        color : #01bf71; 
        transition : all 0.2s ease-in-out;
        background : ${({primary}) => (primary? "#01BF71":"#010101")};
    }
};

& [type = 'text'] {
    height : 50px;
    border : none;
    outline : none;
    color : black;
    border-bottom : 1px solid black;
    &:focus{
        border : none;
        border-bottom : 3px solid #01bf71;
    }
};

    & [type = 'email'] {
        height : 50px;
        border : none;
        outline : none;
        color : black;
        border-bottom : 1px solid black;
        &:focus{
            border : none;
            border-bottom : 3px solid #01bf71;
        }
}
`

export const TextArea = styled.textarea`
margin : 10px;
resize: none;
height : 130px;
color : black;
&:focus{
    outline : 3px solid #01bf71;
}
`

export const Location = () => <Iframe 
src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7821.139480314335!2d75.82409059999999!3d11.438743000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1627048119179!5m2!1sen!2sin"
 width={window.screen.width > 760 ? "370" : "300"} 
 height="460" 
 style={{border:0}} 
 allowfullscreen="" 
loading="lazy" />

export const ContactSubTitle = styled.a`
color : #01bf71;
font-size : 13px;
text-decoration : none;
text-align : center;
max-width : 600px;

@media screen and ( max-width : 768px ) {
    font-size : 12px;
}

@media screen and ( max-width : 480px ) {
    font-size : 12px;
}
`
export const DirectContactDetailsWrapper = styled.div`
    font-size : 12px;
    display : flex; 
    margin-top : 12px;
    justify-content : center;`